export const UserTypes = {
	GET_USER_INFO_SUCCESS: "GET_USER_INFO_SUCCESS",
	SELECT_USER: "SELECT_USER",
	GET_USER_META_DATA_SUCCESS: "GET_USER_META_DATA_SUCCESS",
}
